import React, { useCallback, useMemo, useState, useRef } from "react";
import {
    Grid,
    ListItem,
    ListItemButton,
    ListItemText,
    IconButton,
    Box,
    Button,
    Collapse,
    TextField,
    InputAdornment,
} from "@mui/material";
import MinimizeSVG from "../../../../assets/svgs/minimize.svg";
import PopupPlusSVG from "../../../../assets/svgs/popup-plus.svg";
import styles from "./ViewTransferStatusOfAdmission.module.scss";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";
import { useDispatch, useSelector } from "react-redux";
import { setCardFilter } from "../../../../store/reducers/admission.slice";
import { setCardFilter as setCardFilterComparison } from "../../../../store/reducers/comparisonReducers/admissionComparison.slice";
import { OTHER_ADT_OPTIONS } from "../../../../data/admission.data";
// import _ from "lodash";
// import update from "immutability-helper";
import { LoadingButton } from "@mui/lab";
import HtmlTooltip from "../../../../components/shared/HtmlTooltip";
import InfoIcon from "../../../../components/icon/InfoIcon";
import CardTooltipContent from "../../../../components/dashboard/card/CardTooltipContent";
import { Stack } from "@mui/system";
import { PAGE_TYPE } from "../../../../types/pages.type";
import { ADT_TABLE_TYPE, CUSTOM_TAB_TYPE } from "../../../../types/common.type"; // eslint-disable-line no-unused-vars
import { filterDynamicQuestions, isFullAccess, selectedTabAccess } from "../../../../utilis/common";
import { getTransferStatusEligibleTabsForPage } from "./combineTabTransferStatusFilters";
import { usePageConverterAdtAutomation } from "../../../../services/page-converter-adt-automation";

const ViewTransferStatusOfAdmissionMobile = ({
    isDetailsOpen = true,
    handleOnClickRun,
    loading,
    allDynamicCards,
    allPagesCustomTabs = {},
    defaultCardEdited,
    pageConverterSourcePage = null,
}) => {
    const [showDetails, setShowDetails] = useState(isDetailsOpen);
    const [mobileExpandedItem, setMobileExpandedItem] = useState(null);
    const [searchText, setSearchText] = useState("");
    const [showSearch, setShowSearch] = useState(false);
    const cardRef = useRef(null);
    const dispatch = useDispatch();
    const {
        cardFilter: { adtData },
        isAdtLoading,        
    } = useSelector((state) => state.admission);

    const { cardFilter: { adtData: adtDataComparison } } = useSelector((state) => state.admissionComparison);

    const selectedTab = selectedTabAccess();

    const isFullAccessDashboard = isFullAccess();

    const OTHER_ADT_OPTIONS_ARR = useMemo(
        () =>
            isFullAccessDashboard
                ? OTHER_ADT_OPTIONS
                : OTHER_ADT_OPTIONS.filter(option => selectedTab.includes(option.id)),
        [isFullAccessDashboard, selectedTab]
    );

    const OTHER_ADT_OPTIONS_WITH_CUSTOM = useMemo(() => {
        return OTHER_ADT_OPTIONS_ARR.map((option) => {
            if (
                option.id === PAGE_TYPE.HOSPITAL ||
                option.id === PAGE_TYPE.COMMUNITY_TRANSFER ||
                option.id === PAGE_TYPE.DECEASED
            ) {
                let dynamicQuestion = filterDynamicQuestions(allDynamicCards, option.id);
                const eligibleTabsForPage = getTransferStatusEligibleTabsForPage(
                    allPagesCustomTabs?.[option.id]
                );
                const hasExtra = (dynamicQuestion && dynamicQuestion.length > 0) || eligibleTabsForPage.length > 0;

                if (hasExtra) {
                    let childrenData = option.children;
                    if (option.id === PAGE_TYPE.HOSPITAL) {
                        childrenData = childrenData?.map((item) => {
                            if (
                                item.defaultCardAccessor === "shiftData" &&
                                defaultCardEdited?.length > 0 &&
                                defaultCardEdited?.find((ele) => ele.accessor === item.defaultCardAccessor)?.customQuestionOptions?.length > 0
                            ) {
                                const customQuestionOptions = defaultCardEdited?.find((ele) => ele.accessor === item.defaultCardAccessor)?.customQuestionOptions;
                                return { ...item, customQuestionOptions };
                            }
                            return item;
                        });
                    }

                    const children = childrenData ? [...childrenData] : []; // Create a copy

                    dynamicQuestion.forEach((ele) => {
                        children.push({
                            id: ele?.accessor,
                            label: ele?.label || ele?.tableLabel,
                            parentId: option?.id,
                            isSelected: false,
                            type: ADT_TABLE_TYPE.CUSTOM,
                            validationBase: ele?.validationBase,
                            customQuestionInputType: ele?.customQuestionInputType,
                            customQuestionOptions: ele?.customQuestionOptions,
                            validationOptions: ele?.validationOptions,
                            accessor: ele?.accessor,
                            questionId: ele?._id,
                            dateAnalysisStartQuestion: ele?.dateAnalysisStartQuestion,
                            dateAnalysisEndQuestion: ele?.dateAnalysisEndQuestion,
                            isDefaultCard: ele?.isDefaultCard,
                            existingAccessor: ele?.existingAccessor,
                        });
                    });

                    eligibleTabsForPage.forEach((tab) => {
                        children.push({
                            id: tab?.accessor,
                            label: tab?.title ?? tab?.label,
                            parentId: option?.id,
                            isSelected: false,
                            type: ADT_TABLE_TYPE.CUSTOM,
                            accessor: tab?.accessor,
                            questionId: tab?._id,
                            customTab: tab,
                            isCustomTab: true,
                            isShared: tab?.isShared,
                            isCustomShare: tab?.isCustomShare,
                            shareCount: tab?.shareCount,
                            isUniversalAccess: tab?.isUniversalAccess,
                            isHidden: tab?.isHidden,
                        });
                    });

                    return { ...option, children }; // Create a new option object with updated children
                }
            }
            return option; // Return the original option if no changes
        });
    }, [OTHER_ADT_OPTIONS_ARR, allDynamicCards, allPagesCustomTabs, defaultCardEdited]);

    usePageConverterAdtAutomation({
        pageConverterSourcePage,
        otherAdtOptionsWithCustom: OTHER_ADT_OPTIONS_WITH_CUSTOM,
        loading,
        dispatch,
        handleTransferStatusRun: handleOnClickRun,
    });

    // const handleChangeButton = useCallback(
    //     (newItem) => {
    //         const selectedItem = _.find(adtData, { id: newItem.id });

    //         if (!selectedItem) {
    //             const latestData = update(adtData, { $push: [newItem] });
    //             dispatch(setCardFilter({ adtData: latestData }));

    //             const latestDataComparison = update(adtDataComparison, { $push: [newItem] });
    //             dispatch(setCardFilterComparison({ adtData: latestDataComparison }));
    //         } else {
    //             const spliceIndex = adtData.findIndex(function (o) {
    //                 return o.id === newItem.id;
    //             });
    //             const latestFacilityList = update(adtData, { $splice: [[spliceIndex, 1]] });
    //             dispatch(setCardFilter({ adtData: latestFacilityList }));

    //             const spliceIndexComparison = adtDataComparison.findIndex(function (o) {
    //                 return o.id === newItem.id;
    //             });
    //             const latestFacilityListComparison = update(adtDataComparison, { $splice: [[spliceIndexComparison, 1]] });
    //             dispatch(setCardFilterComparison({ adtData: latestFacilityListComparison }));
    //         }
    //     },
    //     [adtData, adtDataComparison, dispatch]
    // );



    // const checkSelectedVal = (selectedADTTableData, childItem) => {
    //     if (selectedADTTableData && selectedADTTableData.length > 0) {
    //         const selectedData = _.find(selectedADTTableData, { childId: childItem.id });
    //         if (selectedData) {
    //             return true;
    //         }
    //         return false;
    //     } else {
    //         return false;
    //     }
    // };

    const handleOnclickChildButton = useCallback(
        (type, childItem) => {
            // First, ensure the parent item exists in adtData
            let dataArray = [...adtData];
            let dataArrayComparison = [...adtDataComparison];

            // Find or create the parent item
            let parentItem = dataArray.find(item => item.id === type);
            if (!parentItem) {
                // Create parent item from OTHER_ADT_OPTIONS_WITH_CUSTOM
                const optionItem = OTHER_ADT_OPTIONS_WITH_CUSTOM.find(option => option.id === type);
                if (optionItem) {
                    parentItem = { ...optionItem, isSelected: false };
                    dataArray.push(parentItem);
                    dataArrayComparison.push({ ...parentItem });
                }
            }

            if (parentItem) {
                // Update the child selection
                const updatedChildren = parentItem.children.map((p) =>
                    p.id === childItem.id
                        ? { ...p, isSelected: !p.isSelected }
                        : p
                );

                // Check if any children are selected
                const hasSelectedChildren = updatedChildren.some(child => child.isSelected);

                // Update parent item
                const updatedParentItem = {
                    ...parentItem,
                    children: updatedChildren,
                    isSelected: hasSelectedChildren
                };

                // Update the arrays
                const updatedDataArray = dataArray.map(item =>
                    item.id === type ? updatedParentItem : item
                );

                const updatedDataArrayComparison = dataArrayComparison.map(item =>
                    item.id === type ? updatedParentItem : item
                );

                // Remove parent if no children are selected
                const finalDataArray = hasSelectedChildren ? updatedDataArray : updatedDataArray.filter(item => item.id !== type);
                const finalDataArrayComparison = hasSelectedChildren ? updatedDataArrayComparison : updatedDataArrayComparison.filter(item => item.id !== type);

                dispatch(setCardFilter({ adtData: finalDataArray }));
                dispatch(setCardFilterComparison({ adtData: finalDataArrayComparison }));
            }
        },
        [adtData, adtDataComparison, dispatch, OTHER_ADT_OPTIONS_WITH_CUSTOM]
    );

    const checkSelectedButtons = (item) => {
        // Check if item exists in adtData and has isSelected property
        const itemInAdtData = adtData.find(adtItem => adtItem.id === item.id);
        return itemInAdtData ? (itemInAdtData.isSelected !== undefined ? itemInAdtData.isSelected : true) : false;
    };

    const handleMobileItemClick = useCallback((item) => {
        if (mobileExpandedItem?.id === item.id) {
            setMobileExpandedItem(null);
            setShowSearch(false);
            setSearchText("");
        } else {
            setMobileExpandedItem(item);
            setShowSearch(false);
            setSearchText("");
        }
    }, [mobileExpandedItem]);

    const handleSearchToggle = useCallback(() => {
        setShowSearch(!showSearch);
        if (showSearch) {
            setSearchText("");
        }
    }, [showSearch]);

    const handleSearchChange = useCallback((event) => {
        setSearchText(event.target.value);
    }, []);

    const filteredChildren = useCallback((children) => {
        if (!searchText.trim()) return children;
        return children.filter(child => 
            child.label.toLowerCase().includes(searchText.toLowerCase())
        );
    }, [searchText]);

    return (
        <div
            ref={cardRef}
            className={`${styles.fifty} ${styles.ViewThroughADTCard} ${styles.unplannedPlanned}`}
            style={{
                height: `${showDetails ? "initial" : "fit-content"}`,
                marginBottom: "20px",
                width: "108%",
                marginLeft: "-4%"
            }}
            {...(pageConverterSourcePage
                ? { "data-adt-page-converter-source": pageConverterSourcePage }
                : {})}
        >
            <div className={`df aic ffmar-bold fs15 ${styles.cardHeader}`}>
                <Stack sx={{ mt: "10px", mr: "-10px" }}>
                    <HtmlTooltip
                        content={
                            <CardTooltipContent
                                content={`This section is designed to help users easily track and analyze transferred admissions. By connecting the admissions page with other related transfer tabs, you can seamlessly monitor the number of transferred admissions in one place.

                        To make your analysis even more detailed, you can use checkboxes for filtering. These checkboxes are available in both the admissions tab and the transfer status of admissions section. By selecting or deselecting these checkboxes, you can customize the displayed information according to your preferences.
                        
                        The best part is that this filtering process is bidirectional, meaning you can filter the admissions tab based on the transfer status of admissions and vice versa. This two-way filtering ensures that you have complete control over the data you're viewing and analyzing, making it easier to understand and interpret the information at hand.`}
                            />
                        }
                    >
                        <IconButton disableFocusRipple={true} disableRipple={true}>
                            <InfoIcon />
                        </IconButton>
                    </HtmlTooltip>
                </Stack>
                <div className={`${styles.cardAction}`} onClick={() => {
                    const newShowDetails = !showDetails;
                    setShowDetails(newShowDetails);

                    // Scroll to top when expanding
                    if (newShowDetails && cardRef.current) {
                        setTimeout(() => {
                            cardRef.current.scrollIntoView({
                                behavior: 'smooth',
                                block: 'start'
                            });
                        }, 100);
                    }
                }}>
                    {showDetails ? <MinimizeSVG /> : <PopupPlusSVG />}
                </div>
                <p className={`${styles.title}`} style={{ fontSize: '14px' }}>View transfer status of Admissions</p>
            </div>
            {showDetails && !loading && (
                <div className={`${styles.cardContent}'}`}>
                    <Grid container direction={"column"} spacing={1} sx={{ padding: '0px 10px' }}>
                        {OTHER_ADT_OPTIONS_WITH_CUSTOM.map((item, index) => {
                            const labelId = `checkbox-ADT-label-${index}`;
                            const labelName = item.label;
                            const isExpanded = mobileExpandedItem?.id === item.id;
                            const isAnyExpanded = mobileExpandedItem !== null;

                            // Find the corresponding item in adtData to get the current state
                            const currentItemInAdtData = adtData.find(adtItem => adtItem.id === item.id);
                            const childrenToRender = currentItemInAdtData ? currentItemInAdtData.children : item.children;



                            return (
                                <Grid item xs={12} key={`${item.label}${index}_mobileItem`}>
                                    <Box
                                        sx={{
                                            border: checkSelectedButtons(item) ? '2px solid #1976d2' : '1px solid #e0e0e0',
                                            borderRadius: '8px',
                                            backgroundColor: checkSelectedButtons(item) ? '#f5f5f5' : 'white',
                                            transition: 'all 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94)',
                                            opacity: isAnyExpanded && !isExpanded ? 0 : 1,
                                            maxHeight: isAnyExpanded && !isExpanded ? 0 : 350,
                                            overflow: 'hidden',
                                            marginBottom: isAnyExpanded && !isExpanded ? 0 : 0.5,
                                            pointerEvents: isAnyExpanded && !isExpanded ? 'none' : 'auto',
                                            '&:hover': {
                                                backgroundColor: '#f8f8f8',
                                                boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
                                            }
                                        }}
                                    >
                                        <ListItem
                                            className={`${styles.listItem} ${checkSelectedButtons(item) ? styles.selectedItem : null}`}
                                            disablePadding
                                            dense
                                        >
                                            <ListItemButton
                                                edge="start"
                                                onClick={() => {
                                                    handleMobileItemClick(item);
                                                }}
                                                id={labelId}
                                                className={styles.listIconButton}
                                                sx={{
                                                    width: '100%',
                                                    justifyContent: 'space-between'
                                                }}
                                            >
                                                <>

                                                    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', flex: 1 }}>
                                                        {showSearch ? (
                                                            <TextField
                                                                fullWidth
                                                                variant="outlined"
                                                                size="small"
                                                                placeholder="Search options..."
                                                                value={searchText}
                                                                onChange={handleSearchChange}
                                                                autoFocus
                                                                onClick={(e) => e.stopPropagation()}
                                                                InputProps={{
                                                                    startAdornment: (
                                                                        <InputAdornment position="start">
                                                                            <SearchIcon fontSize="small" />
                                                                        </InputAdornment>
                                                                    ),
                                                                    endAdornment: (
                                                                        <InputAdornment position="end">
                                                                            <IconButton
                                                                                onClick={(e) => {
                                                                                    e.stopPropagation();
                                                                                    handleSearchToggle();
                                                                                }}
                                                                                size="small"
                                                                                sx={{ color: '#666' }}
                                                                            >
                                                                                <CloseIcon fontSize="small" />
                                                                            </IconButton>
                                                                        </InputAdornment>
                                                                    )
                                                                }}
                                                                sx={{
                                                                    '& .MuiOutlinedInput-root': {
                                                                        backgroundColor: 'white',
                                                                        borderRadius: '6px',
                                                                        height: '40px'
                                                                    }
                                                                }}
                                                            />
                                                        ) : (
                                                            <>
                                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, width: '100%' }}>
                                                                    {isExpanded && (
                                                                        <IconButton
                                                                            size="small"
                                                                            onClick={(e) => {
                                                                                e.stopPropagation();
                                                                                handleSearchToggle();
                                                                            }}
                                                                            sx={{
                                                                                color: '#666',
                                                                                '&:hover': {
                                                                                    backgroundColor: 'rgba(25, 118, 210, 0.1)'
                                                                                }
                                                                            }}
                                                                        >
                                                                            <SearchIcon fontSize="small" />
                                                                        </IconButton>
                                                                    )}
                                                                    <ListItemText
                                                                        primary={labelName}
                                                                        secondary={item.helperText}
                                                                        sx={{
                                                                            '& .MuiListItemText-secondary': {
                                                                                fontFamily: "manrope-reg",
                                                                                fontSize: '11px',
                                                                                lineHeight: '1.2'
                                                                            }
                                                                        }}
                                                                    />
                                                                </Box>
                                                            </>
                                                        )}
                                                    </Box>

                                                    <IconButton
                                                        sx={{
                                                            transform: isExpanded ? 'rotate(180deg)' : 'rotate(0deg)',
                                                            transition: 'transform 0.3s ease'
                                                        }}
                                                    >
                                                        {isExpanded ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                                                    </IconButton>
                                                </>
                                            </ListItemButton>
                                        </ListItem>

                                        <Collapse
                                            in={isExpanded}
                                            timeout={700}
                                            unmountOnExit={false}
                                        >
                                            <Box sx={{ p: 2, backgroundColor: '#fafafa', height: '260px', overflowY: 'auto' }}>
                                                {childrenToRender && childrenToRender.length > 0 ? (
                                                    <Grid container spacing={1}>
                                                        {filteredChildren(childrenToRender).map((child) => (
                                                            <Grid item xs={12} key={child.id}>
                                                                <Button
                                                                    fullWidth
                                                                    className={`${styles.itemButton} ${child.isSelected ? styles.selected : null}`}
                                                                    variant={child.isSelected ? "outlined" : "contained"}
                                                                    onClick={() => handleOnclickChildButton(item.id, child)}
                                                                    sx={{
                                                                        justifyContent: 'flex-start',
                                                                        textAlign: 'left',
                                                                        padding: '12px 16px',
                                                                        borderRadius: '6px',
                                                                        marginBottom: '4px',
                                                                        ...(child.isSelected && {
                                                                            borderColor: '#1976d2',
                                                                            color: '#1976d2',
                                                                            '&:hover': {
                                                                                borderColor: '#1565c0',
                                                                                color: '#1565c0'
                                                                            }
                                                                        })
                                                                    }}
                                                                >
                                                                    {child.label}
                                                                </Button>
                                                            </Grid>
                                                        ))}
                                                        {filteredChildren(childrenToRender).length === 0 && searchText.trim() && (
                                                            <Grid item xs={12}>
                                                                <Box sx={{
                                                                    p: 2,
                                                                    textAlign: 'center',
                                                                    color: '#666',
                                                                    fontStyle: 'italic'
                                                                }}>
                                                                    No options found for "{searchText}"
                                                                </Box>
                                                            </Grid>
                                                        )}
                                                    </Grid>
                                                ) : (
                                                    <Box sx={{
                                                        p: 2,
                                                        textAlign: 'center',
                                                        color: '#666',
                                                        fontStyle: 'italic'
                                                    }}>
                                                        No options available for this item
                                                    </Box>
                                                )}
                                            </Box>
                                        </Collapse>
                                    </Box>
                                </Grid>
                            );
                        })}
                    </Grid>
                    <Grid container justifyContent={"center"} spacing={0} sx={{ padding: 1, mt: 1, mb:1.5 }}>
                        <Grid item>
                            <LoadingButton
                                variant="outlined"
                                size="small"
                                loading={loading}
                                disabled={isAdtLoading}
                                endIcon={<ChevronRightIcon />}
                                loadingIndicator="Loading…"
                                onClick={handleOnClickRun}
                            >
                                Run
                            </LoadingButton>
                        </Grid>
                    </Grid>
                </div>
            )}
        </div>
    );
};

export default ViewTransferStatusOfAdmissionMobile; 